import { createApi } from '@reduxjs/toolkit/dist/query/react';

import {
  createbusinessType,
  CreatebusinessTypeMutation,
  CreatebusinessTypeMutationVariables,
  createindustryType,
  CreateindustryTypeMutation,
  CreateindustryTypeMutationVariables,
  listBusinessType,
  ListBusinessTypeQuery,
  listIndustryType,
  ListIndustryTypeQuery,
} from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';
import { baseQuery } from '../../../utils';


// Define the response type for listBusinessType query

type BusinessType = {
  businesstype: string;
  businesstypeid: number;
  isactive: number;
};

type IndustryType = {
  industrytype: string;
  industrytypeid: number;
  isactive: number;
};

export const BuzIndTypeApi = createApi({
  reducerPath: 'buzIndTypeApi',
  baseQuery: baseQuery,
  tagTypes: ['businessType', 'industryType'],

  endpoints: (builder) => ({
    getBusinessOptions: builder.query<BusinessType[], void>({
      query: () => ({ body: listBusinessType }),
      providesTags: ['businessType'],
      keepUnusedDataFor: RTK_CACHE_LIFETIME,

      transformResponse: (response: ListBusinessTypeQuery) => {
        return (
          response?.listBusinessType?.map((item) => ({
            businesstype: item?.businesstype || '',
            businesstypeid: item?.businesstypeid || 0,
            isactive: item?.isactive || 0,
          })) || []
        );
      },
    }),
    getIndustryOptions: builder.query<IndustryType[], void>({
      query: () => {
        return { body: listIndustryType };
      },
      providesTags: ['industryType'],
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      transformResponse: (response: ListIndustryTypeQuery) => {
        return (
          response?.listIndustryType?.map((item) => ({
            industrytype: item?.industrytype || '',
            industrytypeid: item?.industrytypeid || 0,
            isactive: item?.isactive || 0,
          })) || []
        );
      },
    }),
    createBusinessOptions: builder.mutation<CreatebusinessTypeMutation, CreatebusinessTypeMutationVariables>({
      query: (variables) => ({ body: createbusinessType, variables }),
      invalidatesTags: ['businessType'],
    }),
    createIndustryOptions: builder.mutation<CreateindustryTypeMutation, CreateindustryTypeMutationVariables>({
      query: (variables) => ({ body: createindustryType, variables }),
      invalidatesTags: ['industryType'],
    }),
  }),
});

export const {
  useGetBusinessOptionsQuery,
  useLazyGetBusinessOptionsQuery,
  useGetIndustryOptionsQuery,
  useLazyGetIndustryOptionsQuery,
  useCreateBusinessOptionsMutation,
  useCreateIndustryOptionsMutation,
  usePrefetch,
} = BuzIndTypeApi;
